import React, { useEffect } from 'react'
import { CartItem } from './CartItem'
import { Button, Chip, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { resetCartItemRemoveStatus, selectCartItemRemoveStatus, selectCartItems } from '../CartSlice'
import { selectLoggedInUser } from '../../auth/AuthSlice'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import {motion} from 'framer-motion'

export const Cart = ({checkout}) => {
    const items=useSelector(selectCartItems)
    const subtotal=items.reduce((acc,item)=>acc + (item.product?.price || 0) * item.quantity,0)
    const totalItems=items.reduce((acc,item)=>acc+item.quantity,0)
    const navigate=useNavigate()
    const theme=useTheme()
    const is900=useMediaQuery(theme.breakpoints.down(900))

    const loggedInUser=useSelector(selectLoggedInUser)

    const cartItemRemoveStatus=useSelector(selectCartItemRemoveStatus)
    const dispatch=useDispatch()

    useEffect(()=>{
        window.scrollTo({
            top:0,
            behavior:"instant"
        })
    },[])

    useEffect(()=>{
        if(items.length===0){
            navigate("/")
        }
    },[items, navigate])

    useEffect(()=>{
        if(cartItemRemoveStatus==='fulfilled'){
            toast.success("Product removed from cart")
        }
        else if(cartItemRemoveStatus==='rejected'){
            toast.error("Error removing product from cart, please try again later")
        }
    },[cartItemRemoveStatus])

    useEffect(()=>{
        return ()=>{
            dispatch(resetCartItemRemoveStatus())
        }
    },[dispatch])

  return (
    <Stack justifyContent={'flex-start'} alignItems={'center'} mb={'5rem'} >

        <Stack width={is900?'auto':'50rem'} mt={'3rem'} paddingLeft={checkout?0:2} paddingRight={checkout?0:2} rowGap={4} >

            {/* cart items */}
            <Stack rowGap={2}>
            {
                items && items.map((item)=>(
                    <CartItem
                        key={item._id}
                        id={item._id}
                        title={item.product?.title || 'Product'}
                        brand={item.product?.brand?.name || 'Nexocart Store'}
                        category={item.product?.category?.name || 'Perfume'}
                        price={item.product?.price || 0}
                        quantity={item.quantity}
                        thumbnail={item.product?.thumbnail || item.product?.images?.[0] || ''}
                        stockQuantity={item.product?.stockQuantity || 0}
                        productId={item.product?._id || item.product?.id || ''}
                    />
                ))
            }
            </Stack>
            
            {/* subtotal */}
            {!checkout && (
            <Stack flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>

                <Stack>
                    <Typography variant='h6' fontWeight={500}>Subtotal</Typography>
                    <Typography>Total items in cart {totalItems}</Typography>
                    <Typography variant='body1' color={'text.secondary'}>Delivery will be calculated at checkout.</Typography>
                </Stack>

                <Stack>
                    <Typography variant='h6' fontWeight={500}>Rs. {subtotal}</Typography>
                </Stack>

            </Stack>
            )}
            
            {/* checkout or continue shopping */}
            {
            !checkout && 
            <Stack rowGap={'1rem'}>
                {loggedInUser?._id ? (
                    <Button variant='contained' component={Link} to='/checkout'>Checkout</Button>
                ) : (
                    <Button variant='contained' onClick={()=>navigate('/login',{state:{from:'/checkout'}})}>Login to Checkout</Button>
                )}
                <motion.div style={{alignSelf:'center'}} whileHover={{y:2}}><Chip sx={{cursor:"pointer",borderRadius:"8px"}} component={Link} to={'/'} label="or continue shopping" variant='outlined'/></motion.div>
            </Stack>
            }
    
        </Stack>


    </Stack>
  )
}
